import type { GreeningQuestionItem } from '../../services/greeningApi';

/** Cada pergunta do histórico carregado, inclusive as que a lista antes escondia. */
export function greeningQuestionCount(items: GreeningQuestionItem[]): number {
  return items.length;
}
